import mixpanel, {
  Callback,
  Dict,
  Mixpanel,
  Query,
  RequestOptions,
} from 'mixpanel-browser';

const mixpanelEnabled = !!process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN;

if (mixpanelEnabled && process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN) {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN);
}

const Wrapper: Pick<Mixpanel, 'track' | 'track_links'> = {
  track: (
    eventName: string,
    properties?: Dict,
    optionsOrCallback?: RequestOptions | Callback,
    callback?: Callback
  ): void => {
    mixpanelEnabled &&
      mixpanel.track(eventName, properties, optionsOrCallback, callback);
  },
  track_links: (
    query: Query,
    eventName: string,
    properties?: Dict | (() => void)
  ): void => {
    mixpanelEnabled && mixpanel.track_links(query, eventName, properties);
  },
};

export default Wrapper;
